import {useMemo} from "react";
import {useRemoteData} from "../../common/utils/useRemoteData";
import {fetchRelatedProducts} from "../../features/catalog/infrastructure/CatalogService";
import {mapRemoteData} from "../../common/domain/RemoteData.model";
import {useComercialContext} from "../../comercial/ComercialContext";

export const useRelatedProducts = (productCode) => {
    const { actingAsCliente } = useComercialContext();

    const fetchFn = useMemo(() =>
        () => fetchRelatedProducts(productCode, {amount: 50, page: 0}, actingAsCliente?.numCliente ?? null)
                .then(rd => mapRemoteData(rd, ({content}) => content)),
        [productCode, actingAsCliente]
    );

    const relatedProductsRemoteData = useRemoteData(
        {
            initial: null,
            dataFetchingCallback: fetchFn
        });

    return {relatedProductsRemoteData};
};
